import BaseService from '../base.service';

export class WithdrawService {
  // 提现操作
  static async withdrawApi(data) {
    return BaseService.post('/web/withdraw', data);
  }

  // 获取提现列表
  static async withdrawListApi(queryOptions) {
    return BaseService.get('/web/withdraw', queryOptions);
  }
}
